(() => {
  function refreshAgenda(agenda) {
    const parts = new Intl.DateTimeFormat('en-CA', {timeZone: 'Europe/Zurich', year: 'numeric', month: '2-digit', day: '2-digit'}).formatToParts(new Date());
    const part = type => parts.find(item => item.type === type).value;
    const today = `${part('year')}-${part('month')}-${part('day')}`;
    const validDate = value => /^\d{4}-\d{2}-\d{2}$/.test(value) && new Date(`${value}T12:00:00Z`).toISOString().slice(0, 10) === value;
    const cards = [...agenda.querySelectorAll('.event-card')];
    for (const card of cards) {
      const start = card.dataset.startDate || '';
      const end = card.dataset.endDate || start;
      let valid = false;
      try { valid = validDate(start) && validDate(end) && end >= start; } catch {}
      card.hidden = !valid || end < today;
    }
    cards.sort((a, b) => (a.dataset.startDate || '').localeCompare(b.dataset.startDate || '')).forEach(card => agenda.querySelector('.events-grid').append(card));
    const visibleCount = cards.filter(card => !card.hidden).length;
    const count = agenda.querySelector('.events-count');
    const lang = document.documentElement.lang.slice(0, 2);
    const unit = {fr: ['rendez-vous', 'rendez-vous'], de: ['Termin', 'Termine'], en: ['event', 'events']}[lang] || ['rendez-vous', 'rendez-vous'];
    count.textContent = `${visibleCount} ${unit[visibleCount === 1 ? 0 : 1]}`;
    count.hidden = !visibleCount;
    agenda.querySelector('.events-grid').hidden = !visibleCount;
    agenda.querySelector('.events-empty').hidden = !!visibleCount;
    const note = agenda.querySelector('.events-agenda-note');
    if (note) note.hidden = !visibleCount;
  }
  const refresh = () => document.querySelectorAll('[data-events-agenda]').forEach(refreshAgenda);
  refresh();
  document.addEventListener('visibilitychange', () => {if (!document.hidden) refresh();});
  document.addEventListener('shopify:section:load', refresh);
})();
